import { DepositIcon, ExchangeIcon, SendIcon } from '@icons'
import {
  isOwnerOrAdministrator,
  paths,
  selectCurrentUserRole,
  useAppSelector,
  useMyAccountAccessQry
} from 'mmfintech-backend-api'
import type { AggregatedBalance } from 'mmfintech-backend-api/types'
import { extractCurrencyCode, formatMoney, tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useHistory } from 'react-router-dom'

import './AccountsSection.scss'

interface Props {
  balance: AggregatedBalance | null
}

function AccountsSection({ balance }: Props) {
  const customerRole = useAppSelector(selectCurrentUserRole)

  const history = useHistory()
  const { hasAnyWritePermission } = useMyAccountAccessQry()

  function handleDepositClick() {
    history.push(paths.banking.deposit())
  }

  function handleSendMoneyClick() {
    history.push(paths.banking.send())
  }

  function handleExchangeClick() {
    history.push(paths.banking.exchange())
  }

  return (
    <div className='account-section-wrapper'>
      <div className='balance-container'>
        <div className='label'>{tr('PORTAL.DASHBOARD.ACCOUNTS_TOTAL', 'Total account value')}</div>
        <div data-test='balance'>{formatMoney(balance?.amount, extractCurrencyCode(balance))}</div>
      </div>

      <div className='buttons-container'>
        {isOwnerOrAdministrator(customerRole) && (
          <Button
            type='button'
            color='secondary'
            icon={<DepositIcon />}
            text={tr('PORTAL.DASHBOARD.DEPOSIT_BUTTON', 'Deposit')}
            onClick={handleDepositClick}
            data-test='deposit-button'
            data-for='button-tooltip'
          />
        )}
        {hasAnyWritePermission && (
          <Button
            type='button'
            color='secondary'
            icon={<SendIcon />}
            text={tr('PORTAL.DASHBOARD.SEND_BUTTON', 'Send')}
            onClick={handleSendMoneyClick}
            data-test='send-money-button'
          />
        )}
        {isOwnerOrAdministrator(customerRole) && (
          <Button
            type='button'
            color='secondary'
            icon={<ExchangeIcon />}
            text={tr('PORTAL.DASHBOARD.EXCHANGE_BUTTON', 'Exchange')}
            onClick={handleExchangeClick}
            data-test='exchange-button'
            data-for='button-tooltip'
          />
        )}
      </div>
    </div>
  )
}

export default AccountsSection
